<div (mousedown)="onMouseDown()" (mouseup)="onMouseUp()" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
</div>